export default {
	add_to_calendar: "Adicionar ao Calendário",
	available_on_level: "Disponível no nível",
	begin_date: "Data Inicial",
	check_in: "Confirmar Presença",
	checked_in: "Presença Confirmada",
	code: "Código",
	doesnt_have_a_qrcode_reader_enter_the_check_in_code_bellow: "Não possui um leitor de QR Code? Digite o código abaixo.",
	dont_forget_to_come_and_visit_us_at: "Bem-vindo(a) aos eventos Intel Lovers!",
	end_date: "Data Final",
	enter_the_check_in_code_bellow: "Digite o código de check-in abaixo.",
	enter_your_six_digits_code: "Digite o seu código de seis dígitos",
	event_type: "Tipo de Evento",
	get_back_later_to_check_new_event_available_to_you: "Volte mais tarde para verificar os eventos disponíveis para você.",
	join_exclusive_events_for_intel_rewards_you_users_and_power_up_your_connection_with_the_intel_network: "Conheça os eventos exclusivos para usuários do Intel Te Premia e amplie a sua rede de relacionamento com a comunidade Intel!",
	no_events_are_available_at_the_moment: "Não existem eventos disponíveis no momento.",
	read_the_qrcode_available_at_the_event_to_check_in: "Faça a leitura do QR Code disponível no evento para marcar a sua presença.",
	signed_up: "Inscrito(a)",
	signup: "Inscrever-se",
	thank_you_for_participating_in_our_event_see_you_on_the_next_one: "Obrigado por participar do nosso evento. Até o próximo!",
	the_code_sent_is_invalid_confirm_the_code_with_the_event_organization: "O código enviado é inválido. Por favor, confirme o código com a organização do evento."
}